import { render, staticRenderFns } from "./ListView.vue?vue&type=template&id=52c4ab1c&scoped=true&lang=pug&"
import script from "./ListView.vue?vue&type=script&lang=ts&"
export * from "./ListView.vue?vue&type=script&lang=ts&"
import style0 from "./ListView.vue?vue&type=style&index=0&id=52c4ab1c&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c4ab1c",
  null
  
)

component.options.__file = "ListView.vue"
export default component.exports